var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",class:_vm.align},[(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{class:{ 'primary--text': _vm.icon != '' }},[_vm._v(" "+_vm._s(_vm.status)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }